import React, {useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import * as Yup from 'yup';

import colors from '../../../../../util/colors';
import {strings} from '../../../../../util/strings';
import * as fonts from '../../../../../util/fonts';
import {deepStringObjectMerger} from '../../../../../util/utility';
import './styles.scss';
import {Column, Row} from '../../../../layout';
import {AppForm, AppFormField, AppFormSubmitButton} from '../../../../forms';
import Icon from '../../../../icon';
import {Icons} from '../../../../../util/icons';
import NewInsertNewDataModal from './insert-new-data-modal/NewInsertNewDataModal';
import AppErrorMessage from '../../../../app-error-message';

interface CustomerNotFoundCardProps {
  labels: typeof strings.pt.virtualCard;
  labelsMessages: typeof strings.pt.messages;
  onSubmit(values: any): void;
  submitted: boolean;
  invalidData: boolean;
  buStyles: any;
}

const validationSchema = Yup.object().shape({
  cardNumber: Yup.string()
    .required()
    .max(20)
    .matches(new RegExp('^[a-zA-Z0-9_.-]*$'), ''),
});

function NewCustomerNotFoundCard({
  labels: labelsFromRedux,
  labelsMessages,
  onSubmit,
  submitted,
  invalidData,
  buStyles,
}: CustomerNotFoundCardProps) {
  const labels = deepStringObjectMerger(
    strings.pt.virtualCard,
    labelsFromRedux,
  );
  const [showModal, setShowModal] = useState(false);
  const [hoverErrorIcons, setHoverErrorIcons] = useState(false);
  const [formikContext, setFormikContext] = useState();
  const defineOnMouseFunctions = (
    e: React.MouseEvent,
    fieldNamePar: string,
    dateInput?: boolean,
  ) => {
    var elem: HTMLElement = e.target as HTMLElement;
    let icon: HTMLElement;
    if (!dateInput) {
      icon = elem.nextSibling as HTMLElement;
      defineIconFunctions(icon, fieldNamePar);
    }

    if (
      dateInput &&
      (elem.tagName.includes('svg') || elem.tagName.includes('path'))
    ) {
      icon = elem as HTMLElement;
      defineIconFunctions(icon, fieldNamePar);
    }
  };

  const defineIconFunctions = (icon: HTMLElement, fieldNamePar: any) => {
    if (icon) {
      icon.onmouseover = function () {
        setHoverErrorIcons(true);
      };
      icon.onmouseout = function () {
        setHoverErrorIcons(false);
      };
    }
  };

  const submittedStyle = submitted && {
    background:
      process.env.REACT_APP_DEFAULT_TENANT_ALIAS === 'RS'
        ? 'linear-gradient(#b31c1a, #95050a)'
        : `linear-gradient(${buStyles?.primaryColor}, ${buStyles?.secondaryColor}#20)`,
    border: 'solid 1px #CCCCCC',
  };

  return (
    <Column
      className="non-customer-card-container app-header-card"
      style={{...fonts.M, color: colors.white, ...submittedStyle}}>
      {/* 
          - if the user has submitted the memId/card number:
            - if the user has submitted invalid data
              - if the user has resubmitted the data an error message will be displayed
              - otherwise, the insert new data modal will be displayed if the user clicks in the "insert new data" text
            - otherwise, a message will be displayed saying the your insurance is being veryfied
          - otherwise, the input for inserting the memId/card number will be displayed
         */}
      {submitted ? (
        invalidData ? (
          <Column className="invalid-data-column-container">
            <div
              style={{
                ...fonts.M,
                color: colors.alertRed,
              }}
              className="customer-not-found-input-label customer-not-found-input-responsive-label invalid-data-container">
              {labels?.VCErrorNotFound_title}
            </div>
            <a
              style={{
                ...fonts.ML,
                color: colors.blue,
              }}
              className="customer-not-found-input-label invalid-data-container invalid-data-anchor"
              onClick={() => setShowModal(true)}>
              {labels?.VCErrorNotFound_subtitle}
            </a>
            <NewInsertNewDataModal show={showModal} setShow={setShowModal} />
          </Column>
        ) : (
          <Column className="invalid-data-column-container">
            <div
              style={{...fonts.M, color: colors.alertRed}}
              className="customer-not-found-input-label customer-not-found-input-responsive-label invalid-data-container">
              {labels?.VCError_title}
            </div>
            <div
              style={{...fonts.M, color: colors.black}}
              className="customer-not-found-input-label">
              {labels?.VCError_decription}
            </div>
          </Column>
        )
      ) : (
        <AppForm
          initialValues={{cardNumber: ''}}
          validationSchema={validationSchema}
          onSubmit={(values) => onSubmit(values)}>
          <Row className="customer-not-found-input-label">
            {labels?.VCCardNumber_subtitle}
          </Row>
          <Row className="customer-not-found-input-row">
            <AppFormField
              className="customer-not-found-card-input"
              name="cardNumber"
              placeholder={labels?.VCCardNumber_inputPlaceholder}
              handleFormikContext={(formik) => {
                if (
                  !!!formikContext ||
                  formik.errors !== (formikContext as any).errors
                ) {
                  setFormikContext(formik);
                }
              }}
              onMouseOver={(e) => {
                defineOnMouseFunctions(e, 'cardNumber');
              }}
            />
            {hoverErrorIcons && (
              <AppErrorMessage
                message={
                  (formikContext &&
                    (formikContext as any).errors &&
                    (formikContext as any).errors.code) ||
                  labelsMessages.requiredField
                }
                className="not-found-card-error"
              />
            )}
            <AppFormSubmitButton
              title=""
              customComponent={
                <Icon
                  name={Icons.CHEVRON_RIGHT_CIRCLE}
                  width="52"
                  height="52"
                  changeViewbox
                  viewBox={'0 0 24 24'}
                />
              }
            />
          </Row>
        </AppForm>
      )}
    </Column>
  );
}

const mapStateToProps = ({globalStyles, strings}: any) => ({
  labels: strings.value.pt.virtualCard ?? {},
  labelsMessages: strings.value.pt.messages ?? {},
  buStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(NewCustomerNotFoundCard));
